import { z } from 'zod';
import { UploadedFloorplanSchema } from '../entities/floorplans.js';
import { InspectionsServiceEventBaseSchema, inspectionsServiceEventType } from './service.js';
const floorplanEventType = (eventName) => inspectionsServiceEventType('floorplan', eventName);
export const FloorplanCreatedEventSchema = InspectionsServiceEventBaseSchema.merge(z.object({
    type: floorplanEventType('created'),
    schemaVersion: z.literal(1),
    floorplan: UploadedFloorplanSchema,
}));
